import React from "react"

import { MessageContentBox } from "@/components"

import useStyles from "@/components/ChatMessageBuilder/MessageItem/BaseMessage/styles"

import { getMessageColor } from "@/utils/message"

type MessageItemProps = {
	className?: string
	style?: React.CSSProperties
	childContent: React.ReactElement
}

const MessageItem: React.FC<MessageItemProps> = (props) => {
	const {
		className,
		style,
		childContent
	} = props

	const classes = useStyles()

	return (
		<MessageContentBox
			className={`${classes.messageContent} ${className}`}
			style={{
				backgroundColor: getMessageColor(true),
				...(style || {})
			}}
		>
			{childContent}
		</MessageContentBox>
	)
}

export default MessageItem
